import i18next from 'i18next';

export const printTable = async (
  headers,
  content,
  title = 'Print Document',
  setLoading,
  isLandscape = false,
  columnTotals = null, // { columnIndex: totalValue }
  wideColumns = [],
  narrowColumns = [],
  fontSize = '14px'
) => {
  setLoading(true); // Start loading

  try {
    const isAndroid = /Android/i.test(navigator.userAgent);

    // Create a new window for printing
    // const printWindow = window.open('', '', 'height=600,width=800');
    let printContent = '<html><head><title>' + title + '</title>';
    printContent += '<style>';
    printContent += `
        body { 
          font-family: Arial, sans-serif; 
          margin: 0; 
          padding: 0; 
        }
        table { 
          width: 100%; 
          border-collapse: collapse; 
          margin: 20px 0; 
        }
        th, td { 
          border: 1px solid #ddd; 
          padding: 8px; 
          text-align: left; 
          min-width: 100px;    
          min-height: 30px; 
          max-width: 200px;
          word-break: break-word;
          white-space: normal;
        }
        .wide-col {
          min-width: 250px !important;
          max-width: 400px !important;
        }
        .narrow-col{
          min-width: 50px !important;
          max-width: 100px !important;
        }
        th { 
          background-color: #f2f2f2; 
        }
        .total-row {
          font-weight: bold;
          background-color: #f8f9fa;
        }
       
        @page {
          size: A3 ${isLandscape ? 'landscape' : ''}; /* Set page size to A3 */
          margin: 10mm; /* Adjust margins as needed */
        }
        @media print {
          body { 
            width: 100%; 
            height: 100%; 
          }
          table { 
            width: 100%; 
            font-size: ${fontSize}; /* Adjust font size for better readability */
          }
          th, td { 
            border: 1px solid #000; 
          }
        }
      `;
    printContent += '</style></head><body>';
    printContent += '<h2>' + title + '</h2>';
    printContent += '<table>';

    // Add headers
    // printWindow.document.write('<thead><tr>');
    // headers.forEach((header, index) => {
    //   // printWindow.document.write('<th>' + header + '</th>');
    //   const columnClass = wideColumns.includes(index) ? 'wide-col' : '';
    //   printWindow.document.write(`<th class="${columnClass}">${header}</th>`);
    // });
    // printWindow.document.write('</tr></thead>');

    printContent += '<thead>';
    const headerRows = Array.isArray(headers[0]) ? headers : [headers];
    headerRows.forEach((headerRow) => {
      printContent += '<tr>';
      headerRow.forEach((header, index) => {
        let columnClass = wideColumns.includes(index) ? 'wide-col' : '';
        columnClass = narrowColumns.includes(index)
          ? columnClass + ' narrow-col'
          : columnClass;
        printContent += `<th class="${columnClass}">${header}</th>`;
      });
      printContent += '</tr>';
    });
    printContent += '</thead>';

    // Add content
    printContent += '<tbody>';
    content.forEach((row) => {
      printContent += `<tr">`;
      row.forEach((cell, index) => {
        // printContent +='<td>' + cell + '</td>'
        let columnClass = wideColumns.includes(index) ? 'wide-col' : '';
        columnClass = narrowColumns.includes(index)
          ? columnClass + ' narrow-col'
          : columnClass;

        printContent += `<td class="${columnClass}">${cell}</td>`;
      });
      printContent += '</tr>';
    });

    // Add total row if columnTotals is provided
    if (columnTotals && Object.keys(columnTotals).length > 0) {
      printContent += '<tr class="total-row">';
      headers.forEach((_, index) => {
        if (columnTotals.hasOwnProperty(index)) {
          printContent += '<td>Total: ' + columnTotals[index] + '</td>';
        } else {
          printContent += '<td></td>';
        }
      });
      printContent += '</tr>';
    }

    printContent += '</tbody>';
    printContent += '</table></body></html>';

    if (isAndroid) {
      handleAndroidPrint(printContent);
    } else {
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(printContent);
      printWindow.document.close();
      // Trigger the print dialog
      printWindow.focus();
      printWindow.onafterprint = () => {
        printWindow.close();
      };
      printWindow.print();
    }
  } catch (error) {
    console.error('Error during printing:', error);
  } finally {
    setLoading(false); // Stop loading
  }
};
export const printLogisticTable = async (
  headers,
  content,
  title = 'Print Document',
  setLoading,
  startGroup = [],
  endGroup = []
) => {
  const fontSize = '15px';
  setLoading(true); // Start loading
  const extraWideColumns = [5, 14];
  const wideColumns = [4, 7, 8];
  // const wideColumns = [2, 3, 4, 12];
  const narrowColumns = [1, 13];
  const extraNarrowColumn = [2, 3, 9, 10, 11, 12];
  try {
    const isAndroid = /Android/i.test(navigator.userAgent);
    // Create a new window for printing
    let printContent = '<html><head><title>' + title + '</title>';
    printContent += '<style>';
    printContent += `
        body { 
          font-family: Arial, sans-serif; 
          margin: 0; 
          padding: 0; 
        }
        table { 
          width: 100%; 
          border-collapse: collapse; 
          margin: 20px 0; 
        }
          td{
              min-height: 54px;    
              height: 54px;}
              th{
                min-height: 54px; 
                  height: 54px;}
        th, td { 
          border: 1px solid #ddd; 
          padding: 8px; 
          text-align: left; 
           min-width: 64px;
           max-width: 64px;
          word-break: break-word;
          white-space: normal;
          font-size: ${fontSize};
        

        }
        .exta-wide-col {
    min-width: 160px !important;
    max-width: 160px !important;
        }
        .wide-col {
    min-width: 120px !important;
    max-width: 120px !important;
        }
        .narrow-col{
          min-width: 75px !important;
          max-width: 75px !important;
        }
    .extra-narrow-col{    min-width: 40px !important;
    max-width: 40px !important;}
     
        .total-row {
          font-weight: bold;
          background-color: #f8f9fa;
        }
       .order-group{
          border-left: 3px solid black;
          border-right: 3px solid black;
        }
        .start-group {
         border-left: 3px solid black;
          border-right: 3px solid black;
          border-top: 3px solid black;
        }
        .end-group {
         border-left: 3px solid black;
          border-right: 3px solid black;
          border-bottom: 3px solid black;
        }
            th{
          background-color: #8dec2aed  !important;
          color: #000;
          }
   
          @media print {
            th{
              background-color: #8dec2aed  !important;
              color: #000 !important;
              -webkit-print-color-adjust: exact; /* For Chrome/Safari */
              print-color-adjust: exact;         /* For Firefox */
            }
          }
        @page {
          size: A4 landscape;
          margin: 10mm; /* Adjust margins as needed */
        }
        @media print {
          body { 
            width: 100%; 
            height: 100%; 
          }
          table { 
            width: 100%; 
            font-size: ${fontSize}; /* Adjust font size for better readability */
          }
          th, td { 
            border: 1px solid #000; 
          }
        }
      `;
    printContent += '</style></head><body>';
    printContent += '<h2>' + title + '</h2>';
    printContent += '<table>';

    // Add headers
    // printContent += '<thead><tr>'
    // headers.forEach((header, index) => {
    //   // printContent += '<th>' + header + '</th>'
    //   const columnClass = wideColumns.includes(index) ? 'wide-col' : '';
    //   printContent += `<th class="${columnClass}">${header}</th>`
    // });
    // printContent += '</tr></thead>'

    printContent += '<thead class="logistic-head">';
    const headerRows = Array.isArray(headers[0]) ? headers : [headers];
    headerRows.forEach((headerRow, headerIndex) => {
      printContent += '<tr>';
      headerRow.forEach((header, index) => {
        let columnClass = wideColumns.includes(index) ? 'wide-col' : '';
        columnClass = narrowColumns.includes(index)
          ? columnClass + ' narrow-col'
          : columnClass;
        columnClass = extraNarrowColumn.includes(index)
          ? columnClass + ' extra-narrow-col'
          : columnClass;
        columnClass = extraWideColumns.includes(index)
          ? columnClass + ' exta-wide-col'
          : columnClass;
        // `<th ${headerIndex == 0 && index == 1 ? 'colspan=2' : ''} class="${columnClass}">${header}</th>` //for date on top
        printContent += `<th class="${columnClass}">${header}</th>`;
      });
      printContent += '</tr>';
    });
    printContent += '</thead>';

    // Add content
    printContent += '<tbody>';
    content.forEach((row, index) => {
      let columnClass = startGroup.includes(index) ? 'start-group' : '';
      if (endGroup.includes(index) || index === content.length - 1) {
        columnClass += (columnClass ? ' ' : '') + 'end-group';
      }

      printContent += `<tr class="order-group ${columnClass}">`;
      row.forEach((cell, index) => {
        //printContent += '<td>' + cell + '</td>'
        let columnClass = wideColumns.includes(index) ? 'wide-col' : '';
        columnClass = narrowColumns.includes(index)
          ? columnClass + ' narrow-col'
          : columnClass;
        columnClass = extraNarrowColumn.includes(index)
          ? columnClass + ' extra-narrow-col'
          : columnClass;
        columnClass = extraWideColumns.includes(index)
          ? columnClass + ' exta-wide-col'
          : columnClass;
        printContent += `<td class="${columnClass}">${cell}</td>`;
      });
      printContent += '</tr>';
    });

    // Add total row if columnTotals is provided
    // if (columnTotals && Object.keys(columnTotals).length > 0) {
    //   printContent += '<tr class="total-row">';
    //   headers.forEach((_, index) => {
    //     if (columnTotals.hasOwnProperty(index)) {
    //       printContent += '<td>Total: ' + columnTotals[index] + '</td>';
    //     } else {
    //       printContent += '<td></td>';
    //     }
    //   });
    //   printContent += '</tr>';
    // }

    printContent += '</tbody>';
    printContent += '</table></body></html>';

    if (isAndroid) {
      handleAndroidPrint(printContent);
    } else {
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(printContent);
      printWindow.document.close();
      // Trigger the print dialog
      printWindow.focus();
      printWindow.onafterprint = () => {
        printWindow.close();
      };
      printWindow.print();
    }
  } catch (error) {
    console.error('Error during printing:', error);
  } finally {
    setLoading(false); // Stop loading
  }
};
export const printPickingListTable = async (
  headers,
  content,
  title,
  setLoading,
  customerGroupNames,
  deliveryDateString
) => {
  setLoading(true);
  const startingRowIndex = 0;
  const headerRows = Array.isArray(headers[startingRowIndex])
    ? headers
    : [headers];
  let zoomRatio = 1; // default
  const numberOfColumns = headerRows[startingRowIndex]?.length || 0;

  if (numberOfColumns <= 12) {
    zoomRatio = 2; // Enlarge if not many columns
  }
  if (numberOfColumns > 12 && numberOfColumns <= 25) {
    zoomRatio = 1.5; // Enlarge if not many columns
  }
  try {
    const isAndroid = /Android/i.test(navigator.userAgent);
    let printContent = `<html><head><title>${title}</title>`;

    let styleContent = `
       body { 
          font-family: Arial, sans-serif; 
          margin: 0; 
          padding: 0; 
        }
        table { 
          width: 100%; 
          border-collapse: collapse; 
          margin: 20px 0;
          table-layout: fixed; 
        }
        /* Existing screen-specific styles */
        th:first-child, td:first-child { width: 8%; }
        td{
            min-height: 25px;    
            height: 25px;
          }
        th{
            min-height: 25px; 
            height: 25px;
        }
        th, td { 
          border: 1px solid #ddd; 
          padding: 8px; 
          text-align: left; 
          min-width: 50px; 
          max-width: 200px;
          word-break: break-word;
          white-space: normal;
          font-size: 12px;
        }
        th:first-child, td:first-child { min-width: 100px !important; max-width: 200px !important; }
        .wide-col { min-width: 250px !important; max-width: 400px !important; }
        th { background-color: #f2f2f2; }
        .total-row { font-weight: bold; background-color: #f8f9fa; }
        .top-align{ vertical-align: top; }
        .center-align{ text-align: center; }
        .highlight-row, th{ background-color: #8dec2aed !important; color: #000; }
        thead th { padding:2px; }
         /* header text should not go beyond 9 lines, else header will not repeat on each page */
        thead th > div {
            display: -webkit-box;
            -webkit-line-clamp: 9;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
        }
        @page { size: A4 landscape; margin: 10mm; }
 
        @media print {
          body { width: 100%; height: 100%; }
          table { width: 100%; font-size: 8px; table-layout: fixed; }
          th, td { 
            border: 1px solid #000; 
            padding: 1px 2px; 
            font-size: 8px; 
            word-break: break-word; 
            white-space: normal; 
            min-height: auto !important; 
            min-width: auto !important; 
            max-width: none !important; 
          }

          /* Crucial for header repetition */
          thead { display: table-header-group; page-break-inside: avoid; page-break-after: avoid; }
          thead tr { page-break-inside: avoid; line-height: 1; height: auto !important; }
          thead tr:last-child { page-break-after: avoid; }
          
          /* === NEW/MODIFIED: FORCE TRUNCATION FOR THEAD TH === */
          thead th {
            padding: 1px 2px;
            font-size: 8px;
            line-height: 1;
            vertical-align: middle;
            
            /*  fixed height and truncation for print to force header to fit */
            max-height: 30px;  
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;  
          }
          /* ================================================= */

          tbody { display: table-row-group; }
          tbody tr { page-break-inside: avoid; }
          tbody tr:first-child { page-break-before: avoid; }

          .highlight-row, th{
              background-color: #8dec2aed  !important;
              color: #000 !important;
              -webkit-print-color-adjust: exact; 
              print-color-adjust: exact;         
            }
        }`;

    const lastHeaderRow = Array.isArray(headers[startingRowIndex])
      ? headers[headers.length - 1]
      : headers;
    const numColumns = lastHeaderRow.length;
    let columnWidthPercentage = 100 / numColumns;
    columnWidthPercentage = columnWidthPercentage - 0.01;

    styleContent += `@media print {`;
    for (let i = 1; i <= numColumns; i++) {
      styleContent += `
            thead tr:last-child th:nth-child(${i}),
            tbody td:nth-child(${i}) { 
                width: ${columnWidthPercentage}% !important; 
            }
        `;
    }
    styleContent += `}`;

    styleContent += `
     th:first-child, td:first-child { width: 20%; }
@media print {
  body {
    zoom: ${zoomRatio};
  }
`;

    printContent += `<style>${styleContent} </style></head><body><h2>${title}</h2>`;

    if (deliveryDateString) {
      printContent += `<span style="margin-right:6px;">${i18next.t(
        'DELIVERYDATE',
        {
          ns: 'Order',
        }
      )}
          : ${deliveryDateString}</span>`;
    }
    if (customerGroupNames) {
      printContent += `<span>${i18next.t('CUSTOMERGROUP', { ns: 'Customer' })}: ${customerGroupNames}</span>`;
    }

    printContent += '<table><thead>';

    headerRows.forEach((headerRow, rowIndex) => {
      printContent += '<tr>';
      headerRow.forEach((header, index) => {
        // if(rowIndex == 0 && index == 1) {
        //   printContent+=`<th class="top-align" colspan="${(numberOfColumns-1)}">${header}</th>` ;
        //   return;
        // }
        // Truncate long header text if needed
        const headerText =
          header.length > 50 ? header.substring(0, 47) + '...' : header;
        printContent += `<th class="top-align" title="${header}"><div>${headerText}</div></th>`;
      });
      printContent += '</tr>';
    });
    printContent += '</thead><tbody>';

    content.forEach((row, rowIndex) => {
      if (rowIndex === content.length - 1) {
        printContent += `<tr class="highlight-row">`;
      } else {
        printContent += '<tr>';
      }

      row.forEach((cell, cellIndex) => {
        if (cellIndex === 0) {
          printContent += `<td>${cell}</td>`;
        } else {
          printContent += `<td class="center-align">${cell}</td>`;
        }
      });

      printContent += '</tr>';
    });

    printContent += '</tbody></table></body></html>';

    if (isAndroid) {
      handleAndroidPrint(printContent);
    } else {
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(printContent);
      printWindow.document.close();
      // Trigger the print dialog
      printWindow.focus();
      printWindow.onafterprint = () => {
        printWindow.close();
      };
      printWindow.print();
    }
  } catch (error) {
    console.error('Error during printing:', error);
  } finally {
    setLoading(false); // Stop loading
  }
};

const handleAndroidPrint = (htmlContent) => {
  // const originalContent = document.body.innerHTML;
  // document.body.innerHTML = printContent;
  // setTimeout(() => {
  //   window.print();
  //   setTimeout(() => {
  //     document.body.innerHTML = originalContent;
  //     window.location.reload(); // Optional: Reload to reinitialize app
  //   }, 1000);
  // }, 500);

  // const originalContent = document.body.innerHTML;
  // document.body.innerHTML = htmlContent;
  const originalContent = document.documentElement.innerHTML;
  document.documentElement.innerHTML = htmlContent;
  let afterPrintTriggered = false;
  let focusTriggered = false;

  function tryRestore() {
    if (afterPrintTriggered && focusTriggered) {
      // document.body.innerHTML = originalContent;
      document.documentElement.innerHTML = originalContent;

      window.location.reload(); // Optional
      window.onafterprint = null;
      window.onfocus = null;
    }
  }

  setTimeout(() => {
    window.print();
    window.onafterprint = () => {
      afterPrintTriggered = true;
      tryRestore();
    };
    window.onfocus = () => {
      focusTriggered = true;
      tryRestore();
    };
  }, 500);
};
